import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Link,
  CircularProgress
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BusinessIcon from '@mui/icons-material/Business';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(formData);
      if (result.success) {
        navigate('/');
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError('Error al iniciar sesión. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="auth-container">
      <Paper className="auth-card" elevation={0}>
        <div className="auth-header">
          <div className="auth-logo">
            <BusinessIcon />
          </div>
          <Typography variant="h4" component="h1" className="auth-title">
            Bienvenido de vuelta
          </Typography>
          <Typography variant="body1" className="auth-subtitle">
            Accede a tu cuenta de MetalConnect
          </Typography>
        </div>

        {error && (
          <Alert severity="error" className="error-message">
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} className="auth-form">
          <div className="form-field">
            <TextField
              required
              fullWidth
              id="username"
              label="Nombre de Usuario"
              name="username"
              autoComplete="username"
              autoFocus
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
            />
          </div>
          <div className="form-field">
            <TextField
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            className={`auth-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </Box>

        <div className="auth-divider">
          <span>o continúa con</span>
        </div>

        <div className="social-auth">
          <Button className="social-button" variant="outlined">
            Google
          </Button>
          <Button className="social-button" variant="outlined">
            LinkedIn
          </Button>
        </div>

        <div className="auth-footer">
          <Typography variant="body2">
            ¿No tienes una cuenta?{' '}
            <Link component={RouterLink} to="/register">
              Regístrate aquí
            </Link>
          </Typography>
        </div>
      </Paper>
    </Box>
  );
};

export default Login; 